import React, { useState } from 'react'
import './CheckBoxList.scss'
import '../../../Wizard2/Wizard.scss'
import { Checkbox } from '@tecuity/granite-ui'
import { Checkbox as WizardCheckbox } from '../../../Wizard2/fieldComponents/Form'

export const CheckboxList = ({
  label,
  items,
  checkedList,
  setActiveChanges,
  disabled,
  allowShowOnlyChecked = false,
  defaultShowOnlyChecked = false,
  modalMaxHeight = false,
  useWizardCheckbox = false,
}) => {
  const [showOnlyChecked, setShowOnlyChecked] = useState(defaultShowOnlyChecked)
  return (
    <div className={`CheckBoxListWrapper ${useWizardCheckbox ? 'wizard' : ''}`}>
      <div className="label">{label}</div>
      {allowShowOnlyChecked && (
        <Checkbox
          label="Show Checked Only"
          checked={showOnlyChecked}
          onChange={(checked) => setShowOnlyChecked(checked)}
          customCss={{ marginTop: '5px', marginBottom: '10px' }}
        />
      )}
      <div className={`scrollableCheckboxList ${modalMaxHeight ? 'small-max-height' : ''}`}>
        {items
          .filter((item) =>
            allowShowOnlyChecked && showOnlyChecked ? checkedList.includes(item.id) : true
          )
          .map(({ label, id }) => {
            return useWizardCheckbox ? (
              <WizardCheckbox
                name={id}
                value={checkedList.includes(id)}
                key={id}
                fieldId={id}
                label={label}
                onChange={() => {
                  const tempList = checkedList.slice() // to make copy without reference
                  !tempList.includes(id)
                    ? tempList.push(id)
                    : tempList.splice(tempList.indexOf(id), 1)
                  setActiveChanges(tempList)
                }}
                disabled={disabled}
              />
            ) : (
              <Checkbox
                label={label}
                key={id}
                checked={checkedList.includes(id)}
                onChange={() => {
                  const tempList = checkedList.slice() // to make copy without reference
                  !tempList.includes(id)
                    ? tempList.push(id)
                    : tempList.splice(tempList.indexOf(id), 1)
                  setActiveChanges(tempList)
                }}
                disabled={disabled}
              />
            )
          })}
      </div>
    </div>
  )
}
